/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import MultiSelect from "@kenshooui/react-multi-select";
import { getEndpoints } from "./requests";

export function ViewPermissions(props) {
  const location: any = useLocation();
  let viewData = location.state;
  console.log(viewData, "view");
  const [selectedItems, setSelectedItems] = useState<any>([]);
  const [endpointList, setEndpointList] = useState<any>([]);
  const [description, setDescription] = useState("");
  const [name, setName] = useState("");

  const getEndpointsData = async () => {
    try {
      const { data } = await getEndpoints();
      if (data) {
        const newData = data.map((item: any) => ({
          id: item.name,
          label: item.name,
          disabled: true,
          ...item,
        }));
        setEndpointList(newData);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  useEffect(() => {
    if (viewData) {
      const newViewData = viewData?.permission?.map((item: any) => ({
        id: item.name,
        label: item.name,
        disabled: true,
        ...item,
      }));
      setSelectedItems(newViewData);
      setName(viewData.user_role);
    }
    getEndpointsData();
  }, []);

  return (
    <>
      <div className="row">
        <h2 className="fw-bolder my-2">View Permissions</h2>
        <div className="d-flex mb-4">
          <div className="col-6 me-4">
            <label className=" fw-bold fs-6 mb-2">Name</label>
            <input
              type="text"
              name="name"
              className="form-control form-control-solid mb-3 mb-lg-0"
              autoComplete="off"
              value={name}
              disabled
            />
          </div>
      
        </div>
        <MultiSelect
          items={endpointList}
          selectedItems={selectedItems}
          disabled={endpointList.disabled}
        />
      </div>
    </>
  );
}
